module.exports = __webpack_public_path__ + "static/media/fravents_tutorial.7a38fcc4.mp4";